export enum SettingsUrlParts {
  Invite = 'invite',
  Profile = 'profile',
  Notifications = 'notifications',
  Courses = 'courses',
  SocialAccounts = 'social-accounts',
  Billing = 'billing',
  Location = 'location',
}

export const DEFAULT_SETTINGS_URL_PART = SettingsUrlParts.Profile;

export const SETTINGS_URL_PART_TO_NAME = {
  [SettingsUrlParts.Invite]: 'settings.invite',
  [SettingsUrlParts.Profile]: 'settings.profile',
  [SettingsUrlParts.Notifications]: 'settings.notifications',
  [SettingsUrlParts.Courses]: 'settings.courses',
  [SettingsUrlParts.SocialAccounts]: 'settings.social_accounts',
  [SettingsUrlParts.Billing]: 'settings.billing',
  [SettingsUrlParts.Location]: 'settings.location',
};

export const SETTINGS_ROUTE_DATA_KEY = 'settingsPage';
